import React, { useState } from "react";
import tw from "tailwind-styled-components";
import ComingSoon from "../../Components/ComingSoon";

const AssetManagement = () => {
  const [isAddNotice, setIsAddNotice] = useState(false);
  const handleAddNoticeClose = () => {
    setIsAddNotice(false);
  };
  return (
    <BoxContainer>
      {/* <div
        className={`${isAddNotice ? "flex" : "hidden"
          } h-screen w-screen bg-black/30 backdrop-blur-sm fixed inset-0 transition-all duration-400 ease-in-out`}
      />
      <div
        className={`${isAddNotice ? "translate-x-0" : "translate-x-full"
          } fixed h-screen right-0 top-0 transition-all duration-300 ease-in-out bg-white flex items-start rounded-l-2xl overflow-hidden md:w-1/2 w-full lg:w-1/3 justify-start z-50`}
      >
        <AddNotice
          setIsAddNotice={setIsAddNotice}
          isAddNotice={isAddNotice}
          handleClose={handleAddNoticeClose}
        />
      </div>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          AssetManagement
          <Underline />
        </BoxTitle>
        <ApplyBtn
          type="button"
          onClick={() => {
            setIsAddNotice(true);
          }}
        >
          {"Add AssetManagement"}
        </ApplyBtn>
      </BoxHead>
      {noticeData.map((notice) => (
        <Card key={notice.id}>
          <Title>{notice.title}</Title>
          <ContentWrapper>
            <div
              className={
                notice.media ? "md:col-span-2 md:mr-4" : "md:col-span-3"
              }
            >
              <Description>{notice.description}</Description>
              <MetaInfo>{notice.postingTime}</MetaInfo>
              <MetaInfo>Property: {notice.propertyName}</MetaInfo>
            </div>
            {notice.media && <Image src={notice.media} alt="AssetManagement Media" />}
          </ContentWrapper>
        </Card>
      ))} */}
      <ComingSoon />
    </BoxContainer>
  );
};
const BoxContainer = tw.div`Container py-6 relative`;
const Content = tw.div`text-center p-8 sm:p-12 max-w-xl w-full absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2`;
const Subtitle = tw.p`text-base sm:text-lg text-gray-600`;
const Card = tw.div`bg-white shadow-lg rounded-2xl p-4 w-full mx-auto mt-6 border border-gray-200`;
const Title = tw.h2`text-xl font-bold text-gray-800 mb-2`;
const Description = tw.p`text-gray-600 mb-4`;
const MetaInfo = tw.div`text-sm text-gray-500 mb-2`;
const ContentWrapper = tw.div`grid md:grid-cols-3 grid-cols-1 gap-4`;
const Image = tw.img`w-full object-cover rounded-lg`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-primary-color hover:bg-hover-color py-2.5 text-sm`;

export default AssetManagement;